import { render, staticRenderFns } from "./AttachedFileModal.vue?vue&type=template&id=4b8907ff&"
import script from "./AttachedFileModal.vue?vue&type=script&lang=js&"
export * from "./AttachedFileModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports